import { Link, useLocation } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../contexts/Auth";
import menuItems from "./menuItems";

type MenuLinkProps = React.PropsWithChildren<LinkProps & { active?: boolean }>;

function MenuLink({ active, children, ...props }: MenuLinkProps) {
  return (
    <Link {...props}>
      <Button
        sx={{
          textDecoration: active ? "underline" : "none",
          "&:hover": { textDecoration: active ? "underline" : "none" },
        }}
      >
        {children}
      </Button>
    </Link>
  );
}

export default function HeaderMenu() {
  const { cliente, logout } = useAuth();
  const { pathname } = useLocation();

  const items = menuItems(cliente).filter(({ hidden }) => !hidden);

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexflow: "row nowrap",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(2),
      })}
    >
      {items.map(({ label, to }, index) => (
        <MenuLink to={to} active={to === pathname} key={index}>
          {label}
        </MenuLink>
      ))}

      <Button onClick={logout} startIcon={<LogoutIcon />}>
        Sair
      </Button>
    </Box>
  );
}
